
define('text!templates/filter_list_item_all.html',[],function () { return '<li class="fl-item all {{#allSelected}}selected{{/allSelected}}" data-id="all" title="{{all_text}}">\n\t<label>\n\t\t<input type="checkbox" {{#allSelected}}checked{{/allSelected}}>\n\t\t<span>{{all_text}}</span>\n\t</label>\n</li>';});

